import { render, staticRenderFns } from "./ButtonDownload.vue?vue&type=template&id=662881f2&scoped=true&"
import script from "./ButtonDownload.vue?vue&type=script&lang=js&"
export * from "./ButtonDownload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "662881f2",
  null
  
)

export default component.exports